import { Routes } from '@angular/router';
import { DynamicLoaderComponent } from './components/dynamic-loader/dynamic-loader.component';
import { AppHomeComponent } from './components/app-home/app-home.component';
import { FileProcessingComponent } from './components/file-processing/file-processing.component';
import { BundleUploadComponent } from './components/bundle-upload/bundle-upload.component';
import { SettingsComponent } from './components/settings/settings.component';
import { GoogleAuthDemoComponent } from './components/google-auth-demo/google-auth-demo.component';
import { BlogHomeComponent } from './components/blog-home/blog-home.component';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: BlogHomeComponent, canActivate: [authGuard] },
  { path: 'admin', component: AppHomeComponent, canActivate: [authGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
  { path: 'google-auth-demo', component: GoogleAuthDemoComponent, canActivate: [authGuard] },
  { path: 'test-auth', component: GoogleAuthDemoComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '/home' }
];
